<template>
  <Container :list="this.$nav10" title="校企合作" v-if="isMaxScreen">
        <div class="zsxx">
          <div class="zsxx_top">
              <div class="zsxx_title">
                <div class="breadcrumb">
                  <router-link to="/" class="breadcrumb-item">
                    首页
                  </router-link>
                  <!-- -
                  <router-link to="/zsxx/dtxx?ids=0" class="breadcrumb-item">
                      招生信息
                  </router-link> -->
                  -
                  <span class="breadcrumb-item">校企合作</span>
                </div>
              </div>
          </div>
          <div class="zsxx_bottom">
             <div class="zsxx_content" v-for="(item, index) in list" :key="index">
                <div class="zsxx_content_box" @click="toPage(item)">
                  <div class="zsxx_content_yuan"></div>
                  <div class="zsxx_content_text">{{item.title}}</div>
                </div>
                <div class="zsxx_content_time">{{item.create_time}}</div>
             </div>
          </div>
        </div>
        <Pagination
            v-if="total"
            :total="total"
            @getList="getList"
            :queryParams="queryParams">
        </Pagination>
    </Container>

    <DzzlH5 v-else />
</template>

<script>
import Container from '@/components/Container'
import Pagination from '@/components/pagination'
import DzzlH5 from '@/views/app/zsxx/dzzl/index'
export default {
  name: 'Dzzl',
  components: { Container, Pagination, DzzlH5 },
  props: {},
  data () {
    return {
      isMaxScreen: true,
      list: [],
      total: 0,
      queryParams: {
        page: 1,
        page_size: 15,
        column_id: 7
      }
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getList()
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      this.isMaxScreen = document.body.clientWidth > 850
    })
  },
  methods: {
    async getList () {
      const { data, total } = await this.$get('/ow/article', this.queryParams)
      console.log(data)
      this.list = data
      this.total = total
    },
    toPage (item) {
      if (item.is_jump == 0) {
        this.$router.push({
          path: '/article',
          query: { id: item.id, title: '招生动态', ids: 0 }
        })
        this.$store.commit('setSidebar', this.$nav8)
      } else {
        window.open(item.jump_url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .zsxx {
    width: 836px;
    font-size: 16px;
    color: #333333;
      .zsxx_top {
        display: flex;
        justify-content: flex-start;
        // padding-bottom: 24px;
        // margin-bottom: 50px;
        // border-bottom: 1px solid #02349C;
        .zsxx_title {
          position: relative;
          margin-right: 32px;

        }
        .zsxx_active {
          color: #02349C;
        }
      }
      .zsxx_content {
       display: flex;
       justify-content: space-between;
       align-items: center;
       border-bottom: 1px dashed #DBDBDB;
       margin-bottom: 24px;
        .zsxx_content_box {
          display: flex;
         .zsxx_content_yuan {
            width: 4px;
            height: 4px;
            background: #E88E0D;
            border-radius: 50%;
            margin-top: 8px;
            margin-right: 6px;
          }
         .zsxx_content_text {
           width: 484px;
           overflow: hidden;
           white-space: nowrap;
           text-overflow: ellipsis;
            padding-bottom: 8px;
            cursor: pointer;
          }
        }
        .zsxx_content_time{
          color: #999999;
        }
      }
    }
</style>
